<template>
  <v-autocomplete
    ref="designationList1"
    :items="searchDesignation1"
    :wait="100"
    :get-label="getLabel"
    :auto-select-one-item="false"
    :component-item="SearchTemplate"
    @update-items="searchInputChange"
    @item-selected="selected"
    @change="inputChange"
    placeholder="Search [Designation]"
    id="ddlDesign"
    title="Search Designation (minimum 3 charater required)"
    v-model="searchCode"
  ></v-autocomplete>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import Autocomplete from "v-autocomplete";
import SearchTemplate from "./DesignationSearchTemplate";
import "v-autocomplete/dist/v-autocomplete.css";
import allMasterJS from "../serviceJS/AllMasterJS.js";
vue.use(Autocomplete);
export default {
  name: "DesignationMasterList",
  components: {},
  model: {
    event: "input",
    event: "change",
  },
  props: {
    value: { default: "" },
  },
  data() {
    return {
      searchCode: null,
      searchDesignation1: [],
      selectObj: null,
      SearchTemplate,
    };
  },
  mounted() {
    self = this;
    let _call = this.fetchByInjectValueDesig;
    this.$root.$on("callChangeDesig", function (x, y) {
      _call(x, y);
    });
  },
  watch: {
    value: function (newValue, oldValue) {
      //this.searchCode = newValue;
      //this.$refs.bankList.searchText = newValue;
    },
  },
  methods: {
    fetchByInjectValueDesig(x, y) {
      let self = this;
      self.searchInputChange(x, y, function (obj) {
        if (obj != null && obj != undefined) {
          self.searchCode = {
            desigID: obj[0].desigID,
            desigName: obj[0].desigName,
            desigCode: "",
            isActive: false,
          };
        } else {
          self.searchCode = {
            desigID: -1,
            desigName: "",
            desigCode: "",
            isActive: false,
          };
        }
      });
    },
    getLabel(item) {
      //console.log(item);
      if (item != null) {
        this.$emit("change", item.desigID);
        return item.desigName;
      }
    },
    searchInputChange(text, id, callback) {
      this.searchDesignation1 = [];
      if (text == null) text = "";
      if (text != "") {
        const _data_ = { DesigID: -1, Type: 1, SearchText: text };
        allMasterJS.GetDesigListAutoComplete(_data_).then(
          (response) => {
            if (response.data.length > 0) {
              this.searchDesignation1 = response.data;
              if (typeof callback === "function" && id != null) {
                callback(
                  response.data.filter((l) => {
                    return l.desigID == id;
                  })
                );
              }
            }
          },
          (error) => {}
        );
      }
    },
    clickInput: function () {
      alert("click input");
    },
    clickButton: function () {
      if (this.selectedObj != null) {
      }
    },
    selected: function (obj) {
      if (obj != null && obj != undefined) {
        this.selectedObj = obj;
      }
    },
    enter: function () {
      if (this.selectedObj != null) {
      }
    },
    keyUp: function () {
      //alert("keyup pressed");
    },
    keyDown: function () {
      //alert("keyDown pressed");
    },
    keyRight: function () {
      //alert("keyRight pressed");
    },
    clear: function () {
      //this.ResetData();
      //this.$emit("input", "");
      //this.$emit("change", "");
    },
    escape: function () {
      //this.ResetData();
    },
    inputChange: function (e) {
      //this.$emit("input", "");
      //this.$emit("change", "");
      //alert('change');
      //this.$emit('input', this.searchCode)
      if (e.toString().length == 0) {
        this.$emit("reset", "");
      }
    },
  },
};
</script>
<style>
@import url("../../assets/css/Autocomplete.css");
</style>


// WEBPACK FOOTER //
// src/components/usercontrols/Designation1MasterList.vue